import * as Yup from "yup";

export const DynamicDocumentsValidations = Yup.object().shape({
  title: Yup.string().trim().required("Title is required"),

  //   de_title: Yup.string().trim().nullable().notRequired(),

  description: Yup.string().trim().required("Description is required"),

  //   de_description: Yup.string().trim().nullable().notRequired(),

  sort: Yup.number()
    .typeError("Sort order must be a number")
    .required("Sort order is required")
    .integer("Sort order must be an integer")
    .min(1, "Sort order must be at least 1"),

  url: Yup.string()
    .trim()
    .required("English document URL is required")
    .url("Please enter a valid English document URL"),
  language: Yup.string().required("Language is required"),

  //   de_url: Yup.string()
  //     .trim()
  //     .nullable()
  //     .notRequired()
  //     .url("Please enter a valid German document URL"),
});
